// extracted by mini-css-extract-plugin
export default {"heading-text":"GroceryPreferences-module__heading-text__IsiiG","subheading":"GroceryPreferences-module__subheading__er5AN","tabs":"GroceryPreferences-module__tabs__vnTCs"};